// extracted by mini-css-extract-plugin
export default {"title":"EnrolmentInformation_title__SZqWx","input":"EnrolmentInformation_input__xI-8a","textarea":"EnrolmentInformation_textarea__sVXAC"};